import React from 'react';

import { List, Switch, Space, Form } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import get from 'lodash/get';
import { OrderSections } from '../../constants';
import { Title } from 'app/components/Typography/Title';
import Button from 'app/components/Button';
import styled from '@emotion/styled';
import { Text } from 'app/components/Typography/Text';
import { Spinner } from 'app/components/Spinner';

const Item = styled(List.Item)`
  border: 1px solid rgba(235, 237, 239, 1);
  border-radius: 4px;
  padding: 16px;
  padding-top: 14px;
  // margin-bottom: 20px;
  &:last-child {
    border-bottom: 1px solid rgba(235, 237, 239, 1) !important;
  }
  gap: 16px;
  > div {
    width: 100%;
    flex: 0.5;
    &:last-of-type {
      justify-content: space-between;
    }
  }
`;
const GroupItem = styled(Space)`
  .ant-space-item:first-of-type {
    color: #8991a0;
    margin-bottom: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    text-align: left;
    p {
      margin-bottom: 0;
    }
  }
  .ant-space-item:last-child {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.002em;
    text-align: left;
    p {
      margin-bottom: 0;
    }
  }
`;
const StyledList = styled(List)`
  margin-top: 38px;
  .ant-list-item {
    margin-bottom: 38px;
  }
  .ant-form-item {
    margin-bottom: 0px;
  }
`;
const FormItemSections = (props: any) => {
  const { loading } = props;

  return (
    <>
      <Form.List name="scheme" initialValue={props.value}>
        {(fields) => {
          return (
            <StyledList
              dataSource={fields}
              renderItem={(item: any) => {
                const currentValue = props.value[item.key];
                return (
                  <div key={item.key}>
                    <>
                      <Form.Item>
                        <Title level={5}>
                          #{get(OrderSections, currentValue.name, '')}
                        </Title>
                      </Form.Item>
                      <Item>
                        <GroupItem
                          direction="horizontal"
                          align="center"
                          size={16}
                        >
                          <Form.Item
                            style={{ marginTop: -24 }}
                            name={[item.name, 'enabled']}
                            valuePropName="checked"
                          >
                            <Switch></Switch>
                          </Form.Item>
                          <Space direction="vertical" size={2}>
                            <p>Name of Section</p>
                            <Text>{currentValue.value}</Text>
                          </Space>
                        </GroupItem>
                        <Space>
                          <GroupItem direction="vertical" size={2}>
                            <p>Content Field</p>
                            <p>{currentValue.fields?.length}</p>
                          </GroupItem>
                          <Button
                            type="text"
                            onClick={() => {
                              props.onEdit(currentValue.name);
                            }}
                          >
                            <EditOutlined />
                          </Button>
                        </Space>
                      </Item>
                    </>
                  </div>
                );
              }}
            ></StyledList>
          );
        }}
      </Form.List>
      <Spinner visible={loading} overlay></Spinner>
    </>
  );
};

export default FormItemSections;
